import { useEffect, useState } from 'react';
import type { IUseDirectionOptions } from 'components/map/map-container/hooks/types.ts';

export const useDirection = ({ map, directionDataService }: IUseDirectionOptions) => {
  const [directionsService, setDirectionsService] = useState<google.maps.DirectionsService | null>(null);
  const [directionsRenderer, setDirectionsRenderer] = useState<google.maps.DirectionsRenderer | null>(null);

  useEffect(() => {
    if (map) {
      const newDirectionsService = new google.maps.DirectionsService();
      const newDirectionsRenderer = new google.maps.DirectionsRenderer();

      setDirectionsService(newDirectionsService);
      setDirectionsRenderer(newDirectionsRenderer);
    }
  }, [map]);

  useEffect(() => {
    const directionData = directionDataService?.data;

    if (map && directionsService && directionsRenderer && directionData) {
      directionsService
        .route({
          origin: directionData.origin,
          destination: directionData.destination,
          waypoints: directionData.waypoints?.map((location) => ({ location })),
          travelMode: google.maps.TravelMode.DRIVING,
        })
        .then((result: google.maps.DirectionsResult) => {
          directionsRenderer.setDirections(result);
          directionsRenderer.setMap(map);
        })
        .catch((e) => {
          alert('Could not display directions due to: ' + e);
        });
    }

    return () => {
      directionsRenderer?.setMap(null);
    };
  }, [map, directionsService, directionsRenderer, directionDataService]);
};
